<div class="flex h-full flex-col">
  <div class="border-neutral-200 md:min-h-[98px] md:border-b md:px-5 md:pt-4 md:pt-5">
    <h3 class="text-primary m-0 mb-2 hidden text-lg font-semibold md:block">
      {{ 'examdojo.topics_tree.topics' | transloco }}
    </h3>
    <div class="flex flex-col gap-2 pb-4">
      <div class="flex items-center justify-between gap-2">
        <div class="flex items-center gap-1">
          <span class="text-md text-primary font-medium">{{
            'examdojo.topics_tree.include_partial_matches' | transloco
          }}</span>
          <y42-info-icon [message]="'examdojo.topics_tree.include_partial_matches_tooltip' | transloco"></y42-info-icon>
        </div>
        <mat-slide-toggle
          class="size-m"
          [formControl]="includePartialMatchesCtrl"
          (change)="onMatchModeChange($event.checked)"
          color="primary"
        ></mat-slide-toggle>
      </div>
    </div>
  </div>

  <dojo-question-bank-topics-tree
    class="flex flex-1 flex-col"
    [explorerNodes]="state.explorerNodes"
    [selectedIds]="state.selectedIds"
    (selectedNodesChange)="onSelectionChange($event)"
  ></dojo-question-bank-topics-tree>
</div>
